import React from "react";
import { connect } from "react-redux";
import { Modal, Form, Button, Tabs } from 'antd';

import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";

import DynamicFilter from "../../components/frame/DynamicFilter";
import DynamicButton from "../../components/frame/DynamicButton";
import ReactAbstract from "../../components/abstract/React.abstract";
import dailyReportrexceptionDtatisticsService from "../../services/WorkReport/daily-reportrexception-statistics-service";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';

export default class NoDeliveryMonthlyReport extends ReactAbstract {



    initReload = false
    dataMode = 0
    deleteRowSelection = false
    moduleName = "approval"
    childModuleName = "employeeIncentiveLeave"

    state = {
        currentModalStatus: false,
        currentIndex: null,
        currentData: {},
        currentDataStatus: "loaded",
        filters: {
            start_time: null,
            end_time: null
        },
        data: [],
        dataStatus: "loaded",
    }
    actions = {
        selectAction: dailyReportrexceptionDtatisticsService.fetchHRWorkReportExceptionStatisticsList,

    }
    filterColumn = [
        {
            type: "department"
        }, {
            type: "date",
            label: "结束时间",
            key: "search_end_time",
        }, {
            type: "date",
            label: "开始时间",
            key: "search_start_time",
        }, {
            type: "selectValue",
            label: "类型",
            key: "report_type",
            children: [{
                text: "日报",
                id: 1
            }, {
                text: "周报",
                id: 2
            }, {
                text: "月报",
                id: 3
            }]
        }
    ]

    tableColumn = [{
        title: '报告时间',
        dataIndex: 'report_date_str',
        key: 'report_date_str',
        className: 'table-global-head-small'
    }, {
        title: '工号',
        dataIndex: 'job_number',
        key: 'job_number',
        className: 'table-global-head-small'
    }, {
        title: '员工姓名',
        dataIndex: 'real_name',
        key: 'real_name',
        className: 'table-global-head-small'
    }, {
        title: '英文名',
        dataIndex: 'english_name',
        key: 'english_name',
        className: 'table-global-head-small'
    }, {
        title: '部门',
        dataIndex: 'department_name',
        key: 'department_name',
        className: 'table-global-head-small'
    }, {
        title: '开始时间',
        dataIndex: 'start_time_str',
        key: 'start_time_str',
        className: 'table-global-head-small'
    }, {
        title: '结束时间',
        dataIndex: 'end_time_str',
        key: 'end_time_str',
        className: 'table-global-head-small'
    }, {
        title: "状态",
        dataIndex: 'status_str',
        key: 'status_str',
        className: 'table-global-head-small'
    }, {
        title: '处理结果',
        dataIndex: 'handle_result_str',
        key: 'handle_result_str',
        className: 'table-global-head-short'
    }
    ]






    customComponentWillMount() {
        this.props.fetchDepartmentsList()
    }

    //#region publicChange(更改条件后不会触发查询)
    publicChange = (filters) => this.setState({
        filters: {
            ...this.state.filters,
            ...filters,
        }
    })
    //#endregion


    render() {
        return (
            <div className="app-module-item">
                <div className="app-module-header">
                    <div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
                        <Button type="primary" onClick={this.publicSelect}>
                            <span>查询</span>
                        </Button>
                    </div>
                    <DynamicFilter column={this.filterColumn}
                        departmentsList={this.props.departmentStructure.departmentsList}
                        value={this.dataSource().filters}
                        setFilter={this.publicChange} />
                </div>
                <Modal width="800px"
                    maskClosable={false}
                    visible={this.state.currentModalStatus}
                    title="处理"
                    destroyOnClose={true}
                    onCancel={this.toggleCurrentModal}
                    onOk={this.publicSubmit} >
                    <DynamicForm column={this.formColumn}
                        form={this.props.form}
                        loadStatus={this.state.currentDataStatus}
                        dataSource={this.state.currentData} />
                </Modal>
                <div>
                    <DynamicTable column={this.tableColumn}
                        dataStatus={this.dataSource().dataStatus}
                        dataSource={this.dataSource().data.Data}
                        pagination={{
                            total: this.dataSource().data.Total,
                            pageSize: this.dataSource().data.PageSize,
                            current: this.dataSource().filters.page
                        }}
                        rowSelection={this.rowSelection}
                        setPageFilter={this.publicChangeForSelect} />
                </div>
            </div>
        )
    }
}


const mapStateToProps = state => {
    return {
        departmentStructure: state.departmentStructure,
    }
}

const mapDispatchToProps = {
    fetchDepartmentsList,
}

NoDeliveryMonthlyReport = connect(mapStateToProps, mapDispatchToProps)(Form.create()(NoDeliveryMonthlyReport));



// WEBPACK FOOTER //
// ./src/routes/WorkReport/NoDeliveryMonthlyReport.js